import { createContext } from 'react';

export const UserContext = createContext({
  user: undefined,       // undefined = estado de "carregando"
  setUser: () => {},     // função para alterar o user
  
  // NOVAS PROPRIEDADES PARA O SISTEMA DE FAVORITAS
  userFavorites: [],     // array das subcategorias favoritas do usuário
  setUserFavorites: () => {}, // função para atualizar favoritas
  toggleFavorite: () => {} // função para adicionar/remover favoritas
});